<script lang="ts">
    import Icon from '@iconify/svelte'

    import { helpDocument, load as loadHelp } from './help'

    interface Props {
        tag: string
        conditional?: boolean
    }

    let { tag, conditional = false }: Props = $props()

    const cleanTag = tag.split('#')[0]

    function open(e: Event) {
        e.preventDefault()
        helpDocument.set(tag)
    }

    let visible = $state(false)
    if (conditional) {
        loadHelp(cleanTag).then((data) => {
            if (data != null) visible = true
        })
    } else {
        visible = true
    }
</script>

<style>
    .help-button a {
        color: inherit;
    }
</style>

{#if visible}
    <span class="help-button">
        <a href="/" onclick={open}><Icon inline icon="fa:question-circle" /></a>
    </span>
{/if}
